import { IGetStartCopy } from './../../models/action/activityCopy';
import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/activityCopy';
import { Log } from 'ng2-logger';
import { ActivityCopyService } from '../../api/activityCopy-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import { IGetActivityCopyDatas, IGetActivityCopyList } from '../../models/action/activityCopy';
import * as activityCopyPageAction from '../actions/activityCopy';
import ICourseContentTermWeeks from '../../models/components/course-content-termweeks';
import { CoursePageService } from '../../api/course-page-service';

const T = Translator.create();
const _logger = Log.create('_activityCopyService_sagas');
const _activityCopyService = new ActivityCopyService();
const coursePageService = new CoursePageService();

function* getActivityCopyDatas(params: IGetActivityCopyDatas) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const myYield = _activityCopyService.RequestGetActivityCopyDatasAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData;
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        } else {
            yield put(activityCopyPageAction.SetActivityCopyData(pageData));
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

export function* watchGetActivityCopyDatas() {
    yield takeEvery(constants.actions.GET_ACTIVITY_COPY_DATAS, getActivityCopyDatas);
    return null;
}

export function* ActivityCopySagas() {
    yield all([
        watchGetActivityCopyDatas()
    ]);
}

function* getActivityCopyList(params: IGetActivityCopyList): any {
    if (params.CourseId === '') {
        yield put(activityCopyPageAction.SetActivityList([{
            activityId: '',
            name: '',
            activityType: null,
            prerequisiteActivity: 0,
            prerequisiteActivityName: '',
            isCommon: false,
            termWeekId: '',
            totalCount: 0,
            beginDate: null,
            endDate: null,
        }], params.spinnerId ? params.spinnerId : '', 'set'));
    } else {
        let isError = false;
        let errorList: any;
        let pageData: any;
        try {
            const myYield = yield _activityCopyService.RequestGetActivityListDatasAsync(
                {
                    ClassId: params.ClassId,
                    CourseId: params.CourseId,
                    Skip: params.Skip,
                    Take: params.Take,
                    TermWeekId: params.TermWeekId,
                    weekZero: params.weekZero,
                    IsWeekly: params.IsWeekly,
                    OrderBy: params.OrderBy
                }
            ).then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }

                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
            if (isError) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                });
            } else {
                yield put(activityCopyPageAction.SetActivityList(pageData, params.spinnerId, 'set'));
            }

            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
        } catch (error: any) {
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
            Notification.setNotification('error', error, 'topRight');
        }
    }
}

export function* watchGetActivityCopyList() {
    yield takeEvery(constants.actions.GET_ACTIVITY_LIST, getActivityCopyList);
    return null;
}

function* getStartActivityCopy(params: IGetStartCopy): any {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        if (params.TargetCourseID === null || params.TargetCourseID === undefined || params.TargetCourseID === '') {
            Notification.setNotification('error', T.t('r_activity_copy_target_lesson_error'), 'topRight');
            return false;
        }
        const myYield = yield _activityCopyService.RequestGetStartActivityCopyAsync(
            {
                CopyActivitiesList: params.CopyActivitiesList,
                TargetCourseID: params.TargetCourseID,
                CopyActivityFiles: params.CopyActivityFiles,
            }
        ).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }

            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        } else {
            yield put(activityCopyPageAction.setStartActivityCopy(pageData, params.spinnerId, 'set'));
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

export function* watchGetStartActivityCopy() {
    yield takeEvery(constants.actions.GET_START_ACTIVITY_COPY, getStartActivityCopy);
    return null;
}

export function* ActivityCopyListSagas() {
    yield all([
        watchGetActivityCopyList(),
    ]);
}
